import styled, { css } from 'styled-components';

import { Headline } from '@/components/elements';
import {
  gridCalc,
  laptop,
  tabletLandscape,
  tabletPortrait,
} from '@/components/utils';

import { SuggestionRow } from '../SuggestionRow';
import { Wrapper } from '../Wrapper';

type IStyledSearchHero = {
  $hasTeaser: boolean;
};

export const StyledSearchHero = styled(Wrapper)<IStyledSearchHero>`
  margin-bottom: var(--distance-dynamic-xl);
  padding-top: var(--distance-static-xxl);

  @media screen and (${tabletPortrait}) {
    margin-bottom: 0;
  }

  ${({ $hasTeaser }) =>
    $hasTeaser &&
    css`
      padding-bottom: 0;
    `}
`;

export const StyledHeader = styled.header`
  display: grid;
  gap: var(--distance-static-xxl);
  align-items: flex-end;
  margin-bottom: var(--distance-static-xxl);

  @media screen and (${laptop}) {
    grid-template-columns: 1fr 1fr;
    gap: var(--distance-static-l);
  }
`;

export const StyledHeadline = styled(Headline)`
  @media screen and (${laptop}) {
    padding-right: ${gridCalc(2)};
  }
`;

export const StyledSuggestionRow = styled(SuggestionRow)`
  padding-bottom: 0;

  @media screen and (${tabletPortrait}) {
    padding-top: 0;
    transform: translateY(calc(var(--distance-static-3xl) * -1));
    padding-right: var(--distance-static-3xl);
    padding-left: var(--distance-static-3xl);
  }

  @media screen and (${tabletLandscape}) {
    padding-right: var(--distance-static-4xl);
    padding-left: var(--distance-static-4xl);
  }

  @media screen and (${laptop}) {
    transform: translateY(-50%);
  }
`;
